const availableSocialNetworks = {
    instagram: 'Instagram',
    facebook: 'Facebook',
    youtube: 'Canal do YouTube',
    tiktok: 'TikTok',
    linkedin: 'LinkedIn'
}

export default availableSocialNetworks
